import { baseApi } from "@/core/api/baseApi";
import type { ListLanguagesResponseDTO } from "../../domain/dto/LanguageDTO";
import type { Language } from "../../domain/entities/Language";
import { mapLanguagesResponse } from "./mapper";

export const languagesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // GET SUPPORTED LANGUAGE CATALOG (FOR LANGUAGE PICKERS)
    getLanguages: builder.query<Language[], void>({
      query: () => ({ url: "/languages" }),
      transformResponse: (response: ListLanguagesResponseDTO) =>
        mapLanguagesResponse(response),
      providesTags: ["Languages"],
    }),
  }),
});

export const { useGetLanguagesQuery } = languagesApi;
